import React from 'react';
import PropTypes from 'prop-types';
import './horseRaceLamp.less';

interface IHorseRaceLampPropType {
    prefixCls?: string;
    text?: string;
}

class HorseRaceLamp extends React.Component<IHorseRaceLampPropType, any> {
    public static defaultProps = {
        prefixCls: 'horseRaceLamp',
        text: ''
    };

    public static contextTypes = {
        router: PropTypes.object
    };

    public constructor(props: any, context: any) {
        super(props, context);
    }

    public render(): React.ReactNode {
        const {text} = this.props;
        let doomNode: any[] = [];
        for (let i = 0; i < 6; i++) {
            doomNode.push(
                <li>{text}</li>
            );
        }
        return (
            <div className="HorseRaceLampout">
                <ul className="HorseRaceLampcon">
                    {doomNode}
                </ul>
            </div>
        );
    }
}

export default HorseRaceLamp;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/horseRaceLamp/horseRaceLamp.tsx